document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector('#store_map')) {
        const storeMap = document.getElementById('store_map');
        const addressesList = document.getElementById('addresses_list');

        if (storeMap && addressesList) {
            const wrapper = document.createElement('div');
            wrapper.className = 'store-wrapper';

            storeMap.parentNode.insertBefore(wrapper, storeMap);

            wrapper.appendChild(storeMap);
            wrapper.appendChild(addressesList);
        }
    }
})